import { render } from "./AnswerOptionsBlock.vue?vue&type=template&id=3f7632d7&scoped=true"
import script from "./AnswerOptionsBlock.vue?vue&type=script&lang=js"
export * from "./AnswerOptionsBlock.vue?vue&type=script&lang=js"

import "./AnswerOptionsBlock.vue?vue&type=style&index=0&id=3f7632d7&scoped=true&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7632d7"]])

export default __exports__